import Link from "next/link";

import { type BestQuickPicks } from "@/lib/api/best/quick-picks/schema";

import type { Category } from "../categories";
import { collectLeaves } from "./mobile-panels";

type Props = {
  quickPicksItems: BestQuickPicks | null;
  categories: Category[];
};

export function MobileSeoNav({ quickPicksItems, categories }: Props) {
  const leaves = collectLeaves(categories);

  return (
    <nav
      aria-hidden="true"
      className="sr-only"
    >
      <ul>
        <li>
          <Link
            href="/pages/about"
            tabIndex={-1}
          >
            About Us
          </Link>
        </li>
        {leaves.map((leaf) => (
          <li key={leaf.url}>
            <Link
              href={leaf.url}
              tabIndex={-1}
            >
              {leaf.name}
            </Link>
          </li>
        ))}
        {quickPicksItems?.map((item) => (
          <li key={`${item.category}:${item.id}`}>
            <a
              href={item.url}
              tabIndex={-1}
              rel="noopener noreferrer"
            >
              {item.title} - {item.name}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
